import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOrderComplete = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 129,
	height: 128,
	fill: "none",
	viewBox: "0 0 129 128",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#6BBC88",
		d: "M64.5 16C38.004 16 16.5 37.504 16.5 64C16.5 90.496 38.004 112 64.5 112C90.996 112 112.5 90.496 112.5 64C112.5 37.504 90.996 16 64.5 16ZM51.492 84.592L34.26 67.36C32.388 65.488 32.388 62.464 34.26 60.592C36.132 58.72 39.156 58.72 41.028 60.592L54.9 74.416L87.924 41.392C89.796 39.52 92.82 39.52 94.692 41.392C96.564 43.264 96.564 46.288 94.692 48.16L58.26 84.592C56.436 86.464 53.364 86.464 51.492 84.592Z"
	})
});
const ForwardRef = forwardRef(SvgOrderComplete);
export default ForwardRef;
